import { wrapUrlSafe } from '@alltrails/shared/utils/languageSupport';

const pushHistory = (route, history, languageRegionCode = 'en-US') => {
  const localizedRoute = wrapUrlSafe(route, languageRegionCode);
  history.push(localizedRoute);
};

export { pushHistory };
